module.exports = __webpack_public_path__ + "img/dcim04.ae3c21c8.jpg";